import { render, staticRenderFns } from "./DetailExternalApproval.vue?vue&type=template&id=c21d74b0"
import script from "./DetailExternalApproval.vue?vue&type=script&lang=js"
export * from "./DetailExternalApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports